<template>
  <div>
    <div class="openClassWrap" v-if="isLimit">
      <div class="select_tabs fixed_horizo_center">
        <div class="select_public" @click="openDialog('citySchool')" :class="[citySchoolSelected ? 'activeTab' : '']">
          <span>{{ cityNameSelected }}</span>
          <van-icon v-if="currentOpen === 'citySchool'" name="arrow-up" />
          <van-icon v-else name="arrow-down" />
        </div>
        <div class="select_public" @click="openDialog('courseName')" :class="[coureSelected ? 'activeTab' : '']">
          <span>{{ courseNameSelected }}</span>
          <van-icon v-if="currentOpen === 'courseName'" name="arrow-up" />
          <van-icon v-else name="arrow-down" />
        </div>
        <div class="select_public" @click="openDialog('mianShou')" :class="[mianShouSelectId ? 'activeTab' : '']">
          <span>{{ mianShouSelectName }}</span>
          <van-icon v-if="currentOpen === 'mianShou'" name="arrow-up" />
          <van-icon v-else name="arrow-down" />
        </div>
        <div class="select_public" @click="openDialog('classType')" :class="[classTypeSelectId ? 'activeTab' : '']">
          <span>{{ classTypeSelectName }}</span>
          <van-icon v-if="currentOpen === 'classType'" name="arrow-up" />
          <van-icon v-else name="arrow-down" />
        </div>
        <div class="select_public" @click="openDialog('datePicker')" :class="[selecteDate ? 'activeTab' : '']">
          <span>{{ selecteDate }}</span>
          <van-icon v-if="currentOpen === 'datePicker'" name="arrow-up" />
          <van-icon v-else name="arrow-down" />
        </div>
      </div>
      <div class="openClassInfo">
        <p class="description_class">
          <span>在读班级</span> <span>{{ tocount }}</span> <span>开班计划</span>
          <span>{{ openClassCount }}</span>
        </p>
        <van-list v-model="loading" :finished="finished" loading-text="正在加载中..." finished-text="暂无更多内容了" @load="loadMore" :immediate-check="false">
          <div v-for="(item, index) in openClasslist" :key="index" class="border_class">
            <h4>
              {{ item.cname
              }}<span :class="[Date.now() > new Date(item.begintime.replace(/-/g, '/')).getTime() ? 'green' : '']">
                {{ Date.now() > new Date(item.begintime.replace(/-/g, "/")).getTime() ? "已开班" : "未开班" }}</span
              >
            </h4>
            <div class="classInfoFlex">
              <div class="flex_item">
                <p>开班时间</p>
                <p>{{ item.begintime.split(" ")[0] }}</p>
              </div>
              <div class="flex_item">
                <p>结课时间</p>
                <p>{{ item.endTime }}</p>
              </div>
              <div class="flex_item">
                <p>课程周数</p>
                <p>{{ item.week }}</p>
              </div>
              <div class="flex_item">
                <p>占座人数</p>
                <p>{{ item.nowNum }}</p>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="cover" v-if="isCover"></div>
      <div class="schoolR publicFixed initTr fixed_wrap" ref="citySchool">
        <div class="public_content">
          <span v-for="item in citySchool" :key="item.id" :class="[schoolAreaId === item.id ? 'active' : '']" @click="confirmCity(item)">{{ item.name }}</span>
        </div>
        <div class="footer_public">
          <span @click="resetId('citySchool')">重置</span>
          <span @click="ensureCity">确定</span>
        </div>
      </div>
      <!--   学科列表-->
      <div class="courseList publicFixed initTr fixed_wrap" ref="courseList">
        <div class="public_content courseListContent">
          <span v-for="item in courseList" :key="item.id" :class="[activeCourseId === item.id ? 'active' : '']" @click="confirmCourse(item)">{{ item.shortName }}</span>
        </div>
        <div class="footer_public">
          <span @click="resetId('courseName')">重置</span>
          <span @click="ensureCourse">确定</span>
        </div>
      </div>

      <!--班级类型-->
      <div class="classType publicFixed initTr fixed_wrap" ref="classType">
        <div class="public_content">
          <span v-for="item in classTypeList" :key="item.did" :class="[classTypeId === item.did ? 'active' : '']" @click="confirmClassType(item)">{{ item.dDes }}</span>
        </div>
        <div class="footer_public">
          <span @click="resetId('classType')">重置</span>
          <span @click="ensureClassType">确定</span>
        </div>
      </div>

      <!--类型-->
      <div class="isMianShou publicFixed initTr fixed_wrap" ref="isMianShou">
        <div class="public_content mianShou">
          <span v-for="item in mianShou" :key="item.id" :class="[mianshouId === item.id ? 'active' : '']" @click="confirmMianShou(item)">{{ item.name }}</span>
        </div>
        <div class="footer_public">
          <span @click="resetId('mianshou')">重置</span>
          <span @click="ensureMianShou">确定</span>
        </div>
      </div>

      <!--日期-->
      <div class="datePickers publicFixed initTr fixed_wrap" ref="datePicker">
        <van-calendar
          type="range"
          color="#277FFF"
          @confirm="onConfirm"
          :poppable="false"
          class="datePicker_el"
          :min-date="minDate"
          :max-date="maxDate"
          :default-date="defaultDate"
        />
      </div>
    </div>
    <emptyPage :isLimit="isLimit" />
  </div>
</template>

<script>
import { weoauserCityList, getAllCourseList, classList, classTypeList } from "@/server/api";
import { pageLimit, wefunstatistics } from "@/utils/public";
import { Toast } from "vant";
import emptyPage from "@/components/emptyPage";

export default {
  name: "openClassList",
  data() {
    let startDay = new Date(new Date().getTime() - 29 * 3600 * 1000 * 24).toLocaleDateString();
    let entDay = new Date().toLocaleDateString();
    return {
      schoolSelctTitle: "校区",
      citySchool: [], //校区列表
      courseList: [], //学科列表,
      classTypeList: [], //班级类型列表
      mianShou: [
        {
          name: "面授",
          id: 2,
        },
        {
          name: "非面授",
          id: 1,
        },
      ],
      schoolAreaId: "", //选中校区ID
      schoolName: "", //选中校区name
      activeCourseId: "", //选中学科id
      courseName: "", //所选课程
      classTypeName: "", //选中班级类型name
      classTypeId: "", //点击选中班级类型id
      mianshouName: "面授", //点击选中是否面授
      mianshouId: 2, //点击选中面授id

      coureSelected: "", //参数请求用
      citySchoolSelected: JSON.parse(localStorage.getItem("userInfo")).zsCityId + "", //参数请求校区，
      classTypeSelectId: "", //参数请求
      mianShouSelectId: 2,
      courseNameSelected: "课程",
      cityNameSelected: "校区",
      classTypeSelectName: "班型",
      mianShouSelectName: "面授",

      currentOpen: "",
      isCover: false,
      minDate: new Date(2019, 0, 1),
      maxDate: new Date(new Date().setDate(new Date().getDate() + 330)),
      defaultDate: [new Date(new Date().getTime() - 29 * 3600 * 1000 * 24), new Date()],
      selecteDate: startDay.replace(/\//g, "-") + " - " + entDay.replace(/\//g, "-"),

      pageSize: 30,
      pageNum: 1,
      startTime: startDay.replace(/\//g, "-"),
      endTime: entDay.replace(/\//g, "-"),
      finished: false, //加载列表是否结束标志
      loading: false,
      openClasslist: [], //开班列表
      bzcount: 0,
      openClassCount: 0,
      tocount: 0,
      isLimit: "",
    };
  },
  components: { emptyPage },
  methods: {
    async getSoureZkName() {
      let res = await weoauserCityList();
      if (res.code !== "200") return Toast.fail(res.msg);
      this.citySchool = this.zkNameList = res.data.data;
      for (let i of this.zkNameList) {
        if (i.id === this.citySchoolSelected) {
          this.schoolName = this.cityNameSelected = i.name;
          this.schoolAreaId = i.id;
        }
      }
      let { data: resData } = await getAllCourseList({});
      if (resData.code !== "200") return Toast.fail(resData.msg);
      this.courseList = resData.data;
      let resClass = await classTypeList({});
      if (resClass.code !== "200") return Toast.fail(resClass.msg);
      this.classTypeList = resClass.data;
    },
    confirmCity(val) {
      this.schoolAreaId = val.id;
      this.schoolName = val.name;
    },
    //点击选中学科
    confirmCourse(val) {
      this.activeCourseId = val.id;
      this.courseName = val.shortName;
    },
    //点击面授类型
    confirmMianShou(val) {
      this.mianshouId = val.id;
      this.mianshouName = val.name;
    },
    //点击班级类型
    confirmClassType(val) {
      this.classTypeId = val.did;
      this.classTypeName = val.dDes;
    },

    resetId(val) {
      this.activeCourseId = 0;
      if (val === "courseName") {
        this.courseName = "课程";
        this.activeCourseId = "";
      } else if (val === "citySchool") {
        this.schoolName = "校区";
        this.schoolAreaId = "";
      } else if (val === "classType") {
        this.classTypeId = "";
        this.classTypeName = "班型";
      } else if (val === "mianshou") {
        this.mianshouId = "";
        this.mianshouName = "类型";
      }
    },
    //确认课程
    ensureCourse() {
      this.coureSelected = this.activeCourseId;
      this.isCover = false;
      this.currentOpen = "";
      this.courseNameSelected = this.courseName;
      if (!this.courseNameSelected) this.courseNameSelected = "课程";
      this.$refs.courseList.classList.add("initTr");
    },
    //确认校区
    ensureCity() {
      this.citySchoolSelected = this.schoolAreaId;
      this.isCover = false;
      this.currentOpen = "";
      this.cityNameSelected = this.schoolName;
      if (!this.cityNameSelected) this.cityNameSelected = "校区";
      this.$refs.citySchool.classList.add("initTr");
    },

    //确认班级类型
    ensureClassType() {
      this.classTypeSelectId = this.classTypeId;
      this.isCover = false;
      this.currentOpen = "";
      this.classTypeSelectName = this.classTypeName;
      if (!this.classTypeSelectName) this.classTypeSelectName = "班型";
      this.$refs.classType.classList.add("initTr");
    },

    //确认面授类型
    ensureMianShou() {
      this.mianShouSelectId = this.mianshouId;
      this.isCover = false;
      this.currentOpen = "";
      this.mianShouSelectName = this.mianshouName;
      this.$refs.isMianShou.classList.add("initTr");
    },

    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.isCover = false;
      this.currentOpen = "";
      this.startTime = this.formatDate(start);
      this.endTime = this.formatDate(end);
      this.selecteDate = `${this.startTime} - ${this.endTime}`;
      this.$refs.datePicker.classList.add("initTr");
    },

    //打开弹框
    openDialog(val) {
      this.isCover = true;
      let publicFixed = document.querySelectorAll(".publicFixed");
      for (let i of publicFixed) {
        i.classList.add("initTr");
      }
      if (val === "citySchool") {
        this.$refs.citySchool.classList.remove("initTr");
      } else if (val === "courseName") {
        this.$refs.courseList.classList.remove("initTr");
      } else if (val === "classType") {
        this.$refs.classType.classList.remove("initTr");
      } else if (val === "mianShou") {
        this.$refs.isMianShou.classList.remove("initTr");
      } else if (val === "datePicker") {
        this.$refs.datePicker.classList.remove("initTr");
      }
      this.currentOpen = val;
    },

    //开班计划请求
    async openClassListRfe() {
      this.loading = true;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        course: this.coureSelected,
        czone: this.citySchoolSelected ? Number(this.citySchoolSelected) : "",
        classType: this.mianShouSelectId,
        classTypeDicId: this.classTypeSelectId,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      let res = await classList(params);
      if (res.code !== "200") {
        this.finished = true;
        this.loading = false;
        return Toast.fail(res.msg);
      }
      let before = [];
      let after = [];
      this.loading = false;
      this.tocount = res.data.tocount;
      this.openClassCount = res.data.kbjhcount;
      this.openClasslist = this.openClasslist.concat(res.data.list);
      for (let i of this.openClasslist) {
        if (Date.now() - new Date(i.begintime.replace(/-/g, "/")).getTime() > 0) {
          before.push(i);
        } else {
          after.push(i);
        }
      }
      this.openClasslist = [...after, ...before];
      if (res.data.list.length == 0 || res.data.list.length < this.pageSize) {
        //数据全部加载完成
        this.finished = true;
      } else {
        this.finished = false;
      }
    },
    loadMore() {
      this.pageNum++;
      this.openClassListRfe();
    },

    searchClassList() {
      this.pageSize = 30;
      this.pageNum = 1;
      this.openClasslist = [];
      this.openClassListRfe();
    },
  },
  async created() {
    let that = this;
    await pageLimit("class:query", function (bool) {
      that.isLimit = bool;
    });
    if (this.isLimit) {
      await wefunstatistics("15", window.location.href.split("#")[0]);
      await this.getSoureZkName();
      await this.openClassListRfe();
    }
  },

  watch: {
    citySchoolSelected() {
      this.searchClassList();
    },
    mianShouSelectId() {
      this.searchClassList();
    },
    coureSelected() {
      this.searchClassList();
    },
    classTypeSelectId() {
      this.searchClassList();
    },
    selecteDate() {
      this.searchClassList();
    },
  },
};
</script>

<style scoped lang="less">
.openClassWrap {
  // width: 750px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: #f5f6fa;
  .select_tabs {
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    height: 90px;
    left: 0;
    padding: 16px 0 16px 30px;
    background-color: #ffffff;
    overflow-x: scroll;
    overflow-y: hidden;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.07);
    border: 1px solid #e3e3e4;
    white-space: nowrap;
    z-index: 9;

    /deep/ .select_public {
      display: inline-block;
      padding: 12px 30px;
      background-color: #f6f6f6;
      border-radius: 29px;
      font-size: 24px;
      margin-right: 20px;

      span {
        margin-right: 7px;
        white-space: nowrap;
      }

      &.activeTab {
        border: 2px solid #277fff;
        background-color: #e9f2ff;
        color: #277fff;
      }
    }
  }
  .select_tabs::-webkit-scrollbar {
    display: none;
  }
  .openClassInfo {
    padding: 110px 30px 25px;
    .description_class {
      font-size: 24px;
      margin-bottom: 20px;
      span {
        color: #999999;
        display: inline-block;

        &:nth-child(even) {
          color: #666666;
          margin: 0 16px 0 8px;
        }
      }
    }
    .border_class {
      padding: 23px 0 28px;
      background: linear-gradient(210deg, #d3e6ff 0%, #ffffff 100%);
      box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.18);
      border-radius: 10px;
      margin-bottom: 20px;

      h4 {
        font-size: 28px;
        padding-left: 30px;
        display: flex;
        align-items: center;

        span {
          font-size: 20px;
          margin-left: 16px;
          color: #ffffff;
          padding: 3px 8px;
          background-color: #d8d8d8;
          border-radius: 5px;

          &.green {
            background-color: #5cd35c;
          }
        }
      }

      .classInfoFlex {
        margin-top: 20px;
        display: flex;

        .flex_item {
          width: 25%;
          text-align: center;

          p:first-child {
            font-size: 22px;
            color: #666666;
            margin-bottom: 12px;
          }
          p:last-child {
            font-size: 28px;
            color: #277fff;
            font-weight: 500;
          }
        }
      }
    }
  }
  .cover {
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .publicFixed {
    position: fixed;
    top: 90px;
    background-color: #ffffff;
    z-index: 8;
    width: 100%;
    border-radius: 0 0 16px 16px;
    transition: all 0.4s ease-in-out;
    .datePicker_el {
      height: 1000px;
      padding-bottom: 0;

      /deep/ .van-calendar__header-title {
        height: 66px;
        font-size: 28px;
      }

      /deep/ .van-calendar__day {
        height: 90px;
        font-size: 30px;
      }

      /deep/ .van-calendar__footer {
        height: 120px;
        .van-button {
          height: 50px;
        }
      }

      /deep/ .van-calendar__bottom-info {
        font-size: 20px;
        bottom: 2px;
      }
    }

    &.initTr {
      transform: translateY(-100%);
    }

    .public_content {
      overflow: hidden;
      padding: 8px 0 10px 0;

      span {
        display: inline-block;
        width: 25%;
        text-align: center;
        padding: 23px 0 16px;
        font-size: 28px;
        white-space: nowrap;
      }

      &.courseListContent {
        height: 400px;
        overflow-y: scroll;

        span {
          width: 50%;
        }
      }

      &.mianShou {
        height: 200px;

        span {
          width: 100%;
        }
      }

      .active {
        color: #277fff;
        font-weight: bold;
      }
    }

    .footer_public {
      display: flex;
      background-color: #f5f6f8;
      justify-content: space-around;
      padding: 17px 0;

      span {
        font-size: 28px;
        border-radius: 40px;
        width: 230px;
        padding: 12px 0;
        text-align: center;
      }

      span:first-child {
        color: #277fff;
        border: 2px solid #277fff;
      }

      span:last-child {
        background-color: #277fff;
        color: #ffffff;
      }
    }
  }
}
</style>
